"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.getBooleanishTruthy=e=>!0===e||"true"===e;
//# sourceMappingURL=booleanish.js.map
